import Badge from "ds/components/Badge";
import { BadgeVariants } from "ds/components/Badge/types";
import { TerraformProviderVersionStatus } from "types/generated";

type TerraformProviderVersionStatusConfig = {
  variant: BadgeVariants;
  text: string;
};

/** @public (Knip ignored - used in the file and exported for stories) */
export const PROVIDER_VERSION_STATUSES: Record<
  TerraformProviderVersionStatus,
  TerraformProviderVersionStatusConfig
> = {
  [TerraformProviderVersionStatus.Draft]: { variant: "gray", text: "Draft" },
  [TerraformProviderVersionStatus.Published]: { variant: "blue", text: "Published" },
  [TerraformProviderVersionStatus.Revoked]: { variant: "red", text: "Revoked" },
};

type TerraformProviderVersionStatusBadgeProps = {
  status: TerraformProviderVersionStatus;
  className?: string;
};

const TerraformProviderVersionStatusBadge = ({
  status,
  className,
}: TerraformProviderVersionStatusBadgeProps) => {
  return (
    <Badge
      variant={PROVIDER_VERSION_STATUSES[status].variant}
      type="strong"
      className={className}
      text={PROVIDER_VERSION_STATUSES[status].text}
    />
  );
};

export default TerraformProviderVersionStatusBadge;
